<template>
  <div class="flex1">
      <looker-links-modal
        ref="lookerLinksModal"
        :links="selectedLookerLinks"
      />

      <div style="margin-block: 1rem;">
          <InfoBox :title="'All Experiments'" :description="info.allExperiments.default"></InfoBox>
      </div>
      <div class="row" style="justify-content: space-between">
      <experiment-create style="margin-left: 1rem"></experiment-create>
      <div>
        <button
          type="button"
          :class="`btn btn-sm ${filterBtnColors['hide']}`"
          @click="toggleHideFilter()"
          style="padding: 7px 7px"
        >
          Hiddens
        </button>
      </div>
    </div>
    <div class="row filtes">
      <div class="col-md-2">
          <label>App Name</label>
          <select  class="form-control" @change="(e)=> debouncedUpdateFilters('appId',e.target.value)">
              <option value="">All</option>
              <option v-for="appId in Object.keys(apps)" :key="`appName-${apps[appId]}`"
              :value="appId">{{ apps[appId] }}
              </option>
          </select>
      </div>
      <div class="col-md-2">
          <label>Category</label>
          <select  class="form-control" @change="(e)=> debouncedUpdateFilters('category',e.target.value)">
              <option value="">All</option>
              <option v-for="category,ind in categories" :key="`category-${category}`"
              :value="category">{{ category }}
              </option>
          </select>
      </div>
      <div class="col-md-2">
          <label>Status</label>
          <select  class="form-control" v-model="filterInputs.status.value"  @change="(e)=> debouncedUpdateFilters('status',e.target.value)">
              <option value="">All</option>
              <option v-for="status in statuses" :key="`status-${status}`"
              :value="status">{{ status }}
              </option>
          </select>
      </div>
      
      <div class="col-md-2">
        <label>Is Paused</label>
          <input  class="form-control" type="checkbox" style="max-width: 20px" v-model="filterInputs.is_paused.value" >
          </input>
      </div>

      <div class="col-md-2">
          <label>Start Date From</label>
          <input  class="form-control" type="date" :value="filterInputs.start_date.value" @change="(e)=> debouncedUpdateFilters('start_date',e.target.value)"></input>
      </div>
      <div class="col-md-2">
          <label>End Date To</label>
          <input  class="form-control" type="date" :value="filterInputs.end_date.value" @change="(e)=> debouncedUpdateFilters('end_date',e.target.value)"></input>
      </div>
     
  </div>
    <div class="row titles">
      <div class="col-md-1 col-12">App Name</div>
      <div class="col-md-1 col-12"  @click="changeSortParams('status')"
        style="cursor: pointer">
        {{
            "Status  " +
            (sortParams.field === "name"
              ? sortParams.direction === "ASC"
                ? "&#8595;"
                : "&#8593;"
              : "")
          }}</div>
      <div class="col-md-1 col-12">Exp. Id</div>
      <div
        class="col-md-1 col-12"
        @click="changeSortParams('name')"
        style="cursor: pointer"
      >
        {{
          "Category  " +
          (sortParams.field === "name"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div
        class="col-md-2 col-12"
        @click="changeSortParams('name')"
        style="cursor: pointer"
      >
        {{
          "Experiment Name  " +
          (sortParams.field === "name"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div class="col-md-1 col-12">Desc.</div>
      <div class="col-md-1 col-12">Looker</div>
      <div
        class="col-md-1 col-12"
        @click="changeSortParams('start_date')"
        style="cursor: pointer"
      >
        {{
          "Start  " +
          (sortParams.field === "start_date"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div
        class="col-md-1 col-12"
        @click="changeSortParams('end_date')"
        style="cursor: pointer"
      >
        {{
          "End  " +
          (sortParams.field === "end_date"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div
        class="col-md-1 col-12"
        @click="changeSortParams('pause_date')"
        style="cursor: pointer"
      >
        {{
          "Pause  " +
          (sortParams.field === "pause_date"
            ? sortParams.direction === "ASC"
              ? "&#8595;"
              : "&#8593;"
            : "")
        }}
      </div>
      <div class="col-md-1 col-12 text-center">Actions</div>
    </div>
    
    <div
      class="row mb-1 line-hover"
      v-for="experiment in filteredExperiments"
      :key="`experiment-${experiment.id}`"
    >

    <div class="col-md-1 col-12 center-para" @click="viewExperiment(experiment)">
      <div :class="`app-name`">
           {{ experiment.appName }}
        </div>
    </div>
      <div class="col-md-1 col-12 center-para">
        <div :class="`status-box ${experiment.status}-${experiment.is_paused}`">
          {{ showExperimentStatus(experiment.status, experiment.is_paused) }}
        </div>
      </div>
      <div class="col-md-1 col-12 center-para" style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
        <span  @click="copyExperimentId(experiment.id)">{{
          experiment.id
        }}</span>
      </div>
      <div class="col-md-1 col-12 center-para">
        {{ experiment.category || "-" }}
      </div>

      <div class="col-md-2 col-12 center-para">
        {{ experiment.name }}
      </div>
      <div
        class="col-md-1 col-12 center-para"
        @click="viewExperiment(experiment)"
      >
        <span>
          {{ experiment.description }}
        </span>
      </div>
      <div
        class="col-md-1 col-12 center-para" style=" white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
      >
        <span>
          <template v-if="isLookerLinkObject(experiment.looker_link)">
            <a href="#" @click.prevent="openLookerModal(experiment)">View Generated Looks</a>
          </template>
          <template v-else-if="experiment.looker_link">
            <a :href="experiment.looker_link" target="_blank" rel="noopener noreferrer">{{ experiment.looker_link }}</a>
          </template>
          <template v-else>-</template>
        </span>
      </div>
      <div class="col-md-1 col-12" @click="viewExperiment(experiment)">
        {{
          experiment.start_date
            | moment("utc", "DD.MM.YYYY HH:mm")
            | addUTCAfter
        }}
      </div>
      <div class="col-md-1 col-12" @click="viewExperiment(experiment)">
        {{
          experiment.end_date | moment("utc", "DD.MM.YYYY HH:mm") | addUTCAfter
        }}
      </div>
      <div class="col-md-1 col-12" @click="viewExperiment(experiment)">
        {{
          experiment.pause_date
            | moment("utc", "DD.MM.YYYY HH:mm")
            | addUTCAfter
        }}
      </div>
      <div class="col-md-1 col-12 text-center center-para">
        <popup-menu>
          <template v-slot:trigger>
            <i class="fas fa-ellipsis-v" />
          </template>
          <template v-slot:content>
            <div v-if="canEditThisExperiment(experiment)">
              <div class="text-left">
                <a @click="viewExperiment(experiment)">
                  <i class="fas fa-pen-square" /> Edit
                </a>
              </div>
            </div>
            <a
              v-if="experiment.status == 'started' && !experiment.is_paused"
              @click="changePauseStatus(experiment.id, true)"
              class="pause"
            >
              <i class="fas fa-stop-circle"></i>
              <span style="color: yellow">Pause Exp</span> &nbsp;
              <i
                class="far fa-question-circle"
              ></i>
            </a>
            <a
              v-if="experiment.status == 'started' && experiment.is_paused"
              @click="changePauseStatus(experiment.id, false)"
              style="color: #ffff99"
            >
              <i class="fas fa-stop-circle"></i> Continue Exp
            </a>
            <a
              v-if="experiment.status == 'started'"
              @click="changeStatus(experiment.id, 'ended')"
              style="color: red"
            >
              <i class="fas fa-stop-circle"></i> End Exp
            </a>
            <a
              v-if="experiment.status == 'created'"
              @click="changeStatus(experiment.id, 'started')"
            >
              <i class="fas fa-play"></i> Start Exp
            </a>
            <a @click="duplicateExperiment(experiment.id)">
              <i class="fas fa-copy" /> Duplicate
            </a>
            <div v-if="experiment.status == 'created'">
                <a
                  style="color: red"
                  
                  @click="deleteExperiment(experiment.id)"
                >
                  <i class="fas fa-ban" /> Delete
                </a>
              </div>
            <div v-else style="display: inline">
              <a
                @click="
                  $router.push({
                    name: 'Experiment',
                    params: { id: experiment.id, viewOnly: true },
                  })
                "
              >
                <i class="fas fa-eye" /> View
              </a>
            </div>
          </template>
        </popup-menu>
      </div>
    </div>
  </div>
</template>

<script>
import ExperimentCreate from "../components/ExperimentCreate";
import LookerLinksModal from "../components/common/LookerLinksModal.vue";
import {debounce} from 'lodash'
import FilterHelper, {FilterType} from "../util/filterHelper";
import defaultCategories from "../constants/categories";
  import InfoBox from "../components/common/InfoBox.vue";
  import info from "../constants/info";
import { permissionsMixin } from '../mixins/permissions.mixin';
import { isLookerLinkObject } from '../util/lookerLinkHelper';

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      info: info,
      editList: [],
      sortParams: {
        field: "create_date",
        direction: "DESC",
      },
      categories: defaultCategories.experiment,
      statuses : defaultCategories.status,
      isPaused : false,
      filterInputs : {
          appId: {value: "", type: FilterType.CONTAINS},
          category: {value: "", type: FilterType.EQUALS},
          status:{value: defaultCategories.status[0], type: FilterType.EQUALS},
          start_date: {value: undefined, type: FilterType.DATE_AFTER},
          end_date: {value: undefined, type: FilterType.DATE_BEFORE},
          is_paused: {value: false, type: FilterType.EQUALS}
      },
      showHiddenFilter: false,
      selectedLookerLinks: null,
    };
  },
  computed: {
    apps(){
      console.log(this.$store.getters.apps)
      return this.$store.getters.apps
    },
    experiments() {
      return this.$store.getters.allExperiments;
    },
    filteredExperiments() {
      const filters = this.filterInputs.status.value === "started" ? this.filterInputs : {...this.filterInputs, is_paused: {value: undefined, type: FilterType.EQUALS}}
      const allExperiments = FilterHelper.applyFilters(this.experiments, filters)
      
      allExperiments.sort(this.sorter)
      return allExperiments
    },
    filterBtnColors() {
      return {
        ios: this.iosFilter ? "btn-success" : "btn-secondary",
        android: this.androidFilter ? "btn-success" : "btn-secondary",
        hide: this.showHiddenFilter ? "btn-success" : "btn-secondary",
      };
    },
  },
  methods: {

  debouncedUpdateFilters: debounce(function (key,val) {
      this.$set(this.filterInputs[key], 'value', val);
  }, 300),

    isLookerLinkObject,
    openLookerModal(experiment) {
      this.selectedLookerLinks = experiment.looker_link;
      this.$refs.lookerLinksModal.openModal();
    },
    showExperimentStatus(status, isPaused) {
      if (isPaused && status == "started") {
        return "paused";
      }
      return status;
    },
    duplicateExperiment(id) {
      const experiment = this.experiment(id);
      const payload = {
        name: experiment.name + " Duplicate",
        description: experiment.description + " Duplicate",
        start_date: new Date(this.start_date) * 1,
        end_date: new Date(this.end_date) * 1,
        audience: experiment.audience,
        percentage: experiment.percentage,
        keys: experiment.keys,
        isls: experiment.isls,
        variants: experiment.variants,
        status: "created",
        create_date: Date.now(),
        only_new_users: experiment.only_new_users,
      };
      this.$store.dispatch("configAdd", { type: "experiment", payload });
    },
    viewExperiment(experiment) {
      this.$router.push({path:`/${experiment.appId}/experiments/${experiment.id}`, params: { id: experiment.id } });
    },
    experiment(id) {
      const experiment = this.filteredExperiments.find((item) => item.id == id);
      return experiment ? experiment : {};
    },
    deleteExperiment(id) {
      if (
        confirm(
          `You are trying to delete "${
            this.experiment(id).name
          }" experiment. Are you sure?`
        )
      ) {
        this.$store.dispatch("configDelete", {
          type: "experiment",
          payload: id,
        });
      }
    },
    async changeStatus(id, status) {
      if (await this.checkSurvey(id, status)){
        const experiment = this.experiments.find((el) => el.id == id);
        const data = JSON.parse(JSON.stringify(experiment));
        delete data.id;
        data.status = status;
        if (status == "started") {
          data.start_date = Date.now();
        } else if (status == "ended") {
          data.end_date = Date.now();
        }
        this.$store.dispatch("configEdit", {
          type: "experiment",
          payload: { id, data },
        });
      }
    },
    async checkSurvey(id, status) {
      const isStaging = this.$store.getters.isStaging
      const customConfirm = this.$confirm
      const customConfirmVariables = ['','question', {confirmButtonText: 'Yes', cancelButtonText: 'No'}]
      if (isStaging || status != 'started'){
        return await customConfirm(
          `You are trying to change status of "${
            this.experiment(id).name
          }" experiment. Are you sure?`,...customConfirmVariables
        ).catch(err => {return false})
      }else{
        if (await customConfirm('Is this a monetization experiment?',...customConfirmVariables).catch(e => false)){
          return (
            await customConfirm('Are the products listed in catalog manager?',...customConfirmVariables).catch(e => false) && 
            await customConfirm('Are the products approved in AppStore and PlayStore?',...customConfirmVariables).catch(e => false) && 
            await customConfirm('Is it QA tested?',...customConfirmVariables).catch(e => false) && 
            await customConfirm('Is it tested on staging with test groups?',...customConfirmVariables).catch(e => false) && 
            await customConfirm('Have you checked iap catalog in production?',...customConfirmVariables).catch(e => false) && 
            await customConfirm('Have you checked the production paywall structure?',...customConfirmVariables).catch(e => false) &&
            await customConfirm('Have you checked the pricing tier parameter in production?',...customConfirmVariables).catch(e => false) &&
            await customConfirm('Experiment will start now, remember to check after 1 hour.').catch(e => false)
          )
        }else {
          return (
            await customConfirm('Is it QA tested?',...customConfirmVariables).catch(e => {}) && 
            await customConfirm('Are parameters tested on staging?',...customConfirmVariables).catch(e => {}) &&
            await customConfirm('Experiment will start now, remember to check after 1 hour.').catch(e => false)
          )
        }
      }
    },
    changePauseStatus(id, pauseStatus) {
      let change = pauseStatus ? "pause" : "re-open";
      if (
        confirm(
          `You are trying to ${change} "${
            this.experiment(id).name
          }" experiment. Are you sure?`
        )
      ) {
        const experiment = this.experiments.find((el) => el.id == id);
        const data = JSON.parse(JSON.stringify(experiment));
        delete data.id;
        data["is_paused"] = pauseStatus;
        //latest pause date
        if (pauseStatus) {
          data["pause_date"] = Date.now();
        }
        this.$store.dispatch("configEdit", {
          type: "experiment",
          payload: { id, data },
        });
      }
    },
    copyExperimentId(eid) {
      const tempInput = document.createElement("input");
      tempInput.value = eid;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },
    changeSortParams(field) {
      if (this.sortParams.field === field) {
        this.sortParams.direction =
          this.sortParams.direction === "ASC" ? "DESC" : "ASC";
      } else {
        this.sortParams = { field, direction: "ASC" };
      }
    },
    sorter(a, b) {
      const aField = a[this.sortParams.field] || 0;
      const bField = b[this.sortParams.field] || 0;
      if (typeof aField === "string" && typeof bField === "string") {
        if (aField.toUpperCase() < bField.toUpperCase())
          return this.sortParams.direction === "ASC" ? -1 : 1;
        if (aField.toUpperCase() > bField.toUpperCase())
          return this.sortParams.direction === "ASC" ? 1 : -1;
        return 0;
      }
      if (aField < bField) return this.sortParams.direction === "ASC" ? -1 : 1;
      if (aField > bField) return this.sortParams.direction === "ASC" ? 1 : -1;
      return 0;
    },
    toggleHideFilter() {
      this.showHiddenFilter = !this.showHiddenFilter;
    },
    toggleHidePaused(){
      this.isPaused = !this.isPaused
    }
  },
  components: {
    ExperimentCreate,
    InfoBox,
    LookerLinksModal,
  },
  filters: {
    addUTCAfter(value) {
      if (value) {
        return value + " UTC";
      } else {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
.status-box {
  text-align: center;
  border-radius: 5px;
  padding: 5px;
}

[class*="created"] {
  background-color: #95a5a6;
}

.status-box.started-undefined {
  background-color: #27ae60;
}

.status-box.started-true {
  background-color: #ffff99;
  color: black;
}
.status-box.started-false {
  background-color: #27ae60;
}
[class*="ended"] {
  background-color: #e74c3c;
}

.popup {
  color: white;
  margin: 5px 0;
}
.pause{
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 0.25rem
}
</style>